import React from "react";
import PropTypes from "prop-types";
import "./styles.css";
import { Link } from "react-router-dom";

const TestItemHorizontal = ({ testItem, testItem: { project } }) => {
  return (
    <div className={"test-item-horizontal-root"}>
      <div className={"test-item-horizontal-title"}>{testItem.title}</div>
      <img
        className={"test-item-horizontal-img"}
        src={
          testItem.attachment &&
          `${process.env.REACT_APP_API_URL_BO}private/${testItem.attachment.name}`
        }
      />
      <div className={"test-item-horizontal-project-type"}>
        <Link to={`/test/${testItem.id}/detail`}>
          {project.project_type && project.project_type.name}
        </Link>
      </div>
      <div>
        {Array.isArray(project.medical_visits) && project.medical_visits[0] && (
          <span>Día inicio {project.medical_visits[0].date}</span>
        )}
      </div>
      <div>
        {Array.isArray(project.medical_visits) && project.medical_visits[1] && (
          <span>Día fin {project.medical_visits[1].date}</span>
        )}
      </div>
      {/*<div>Horario : Mañanas</div>*/}
    </div>
  );
};

TestItemHorizontal.propTypes = {
  testItem: PropTypes.object.isRequired
};

export default TestItemHorizontal;



// WEBPACK FOOTER //
// ./src/modules/test/components/TestItemHorizontal/test-item-horizontal.js